import managerFleetService from "@/services/mrfiktiv/services/fleet/managerFleetService";
import { MrfiktivFleetViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

@Module({
  dynamic: true,
  namespaced: true,
  name: "fleetManagerStore",
  store
})
export class FleetManagerStore extends VuexModule {
  _current: MrfiktivFleetViewModelGen | null =
    JSON.parse(window.localStorage.getItem("managerFleetStore") || "{}").state?._current ?? null;

  get current() {
    return this._current;
  }

  @Mutation
  _mutateCurrent(data: MrfiktivFleetViewModelGen) {
    this._current = data;
  }

  @Action
  setCurrent(data: MrfiktivFleetViewModelGen) {
    this.context.commit("_mutateCurrent", data);
  }

  @Action
  async getOne(data: { partnerId: string; fleetId: string }): Promise<MrfiktivFleetViewModelGen> {
    const response = await managerFleetService.findOne(data.partnerId, data.fleetId);

    this.context.commit("_mutateCurrent", response.data);

    return response.data;
  }
}

export const FleetManagerModule = getModule(FleetManagerStore);
